import { Button, Grid } from "@mui/material";
import { CSSProperties, useContext } from "react";
import useLocales from "src/hooks/useLocales";

import Context from "../../context";
import InfoTitle from "./InfoTitle";

// ----------------------------------------------------------------------

export const InfoHeader = () => {
	const { state, values } = useContext(Context);
	const { buttonBackgroundColor, buttonShape, buttonTextColor, buttonTextWeight } = values;

	const { translate } = useLocales();

	const buttonStyle: CSSProperties = {
		borderRadius: buttonShape,
		backgroundColor: buttonBackgroundColor,
		color: buttonTextColor,
		fontWeight: buttonTextWeight === "BOLD" ? 700 : 500
	};

	return (
		<Grid item xs={state.isMobile ? 12 : 6}>
			<InfoTitle />
			{!state.isMobile && (
				<Button variant='contained' size='large' sx={{ mt: 11.1 }} style={buttonStyle}>
					{translate("info_panel.connect_my_account")}
				</Button>
			)}
		</Grid>
	);
};

export default InfoHeader;
